import React, { useState, useEffect } from "react";
import Loader from "../../Components/Common/Loader";
import { Col, Row, Card, CardHeader, CardBody, Button, Dropdown, DropdownItem, DropdownMenu, ButtonGroup, Input, Label, DropdownToggle, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import {getLocalStorageData, displayDateV1, convertDateFormate, getDateByName, getPercentageWithAlertV1,
    currencyFormatWithoutDecimalV1
} from "../../helpers/api_helper";


const OverallWidget = ({widgetData, currency, loading}) => {
    const [showFull, setShowFull] = useState(false);
    const [widgetAjax, setWidgetAjax] = useState(false);
    const [ecomWidgets, setEcomWidgets] = useState([]);

    useEffect(() => {        
        const ecomWidgets = [
                {
                    id: 1,
                    label: "In-Guest Capture Rate",
                    counter: !loading ? widgetData.overall_capture_rate+"%":'',
                    lyPer: !loading ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.vLYCaptureRate).toFixed(2)) :'',
                    budPer: !loading ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.vBDCaptureRate).toFixed(2)):'',
                    fcPer: !loading ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_cover_percent).toFixed(2)):'',
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                    separator: "",
                    lybgClass: (widgetData?.vLYCaptureRate && Number(widgetData?.vLYCaptureRate) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    budbgClass: (widgetData?.vBDCaptureRate && Number(widgetData?.vBDCaptureRate) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    fcbgClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    lyArrowClass: (widgetData?.vLYCaptureRate && Number(widgetData?.vLYCaptureRate) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    budArrowClass: (widgetData?.vBDCaptureRate && Number(widgetData?.vBDCaptureRate) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    fcArrowClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                },
                {
                    id: 2,
                    label: "Revenue Per Resident Guest",
                    counter: !loading ? currencyFormatWithoutDecimalV1(widgetData.request_per_guest, currency):'',
                    lyPer: !loading ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.vLYRequestPerGuest).toFixed(2)):'',
                    budPer: !loading ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.vBDRequestPerGuest).toFixed(2)):'',
                    fcPer: !loading ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_avg_check_percent).toFixed(2)):'',
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                    separator: "",
                    lybgClass: (widgetData?.vLYRequestPerGuest && Number(widgetData?.vLYRequestPerGuest) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    budbgClass: (widgetData?.vBDRequestPerGuest && Number(widgetData?.vBDRequestPerGuest) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    fcbgClass: (widgetData?.fs_avg_check_percent && Number(widgetData?.fs_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    lyArrowClass: (widgetData?.vLYRequestPerGuest && Number(widgetData?.vLYRequestPerGuest) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    budArrowClass: (widgetData?.vBDRequestPerGuest && Number(widgetData?.vBDRequestPerGuest) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    fcArrowClass: (widgetData?.fs_avg_check_percent && Number(widgetData?.fs_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                },
                {
                    id: 3,
                    label: "Resident Revenue",
                    counter: !loading ? currencyFormatWithoutDecimalV1(widgetData.total_revenue, currency):'',
                    lyPer: !loading ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.vLYRevenue).toFixed(2)):'',
                    budPer: !loading ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.vBDRevenue).toFixed(2)):'',
                    fcPer: !loading ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_rev_percent).toFixed(2)):'',
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                    separator: "",
                    lybgClass: (widgetData?.vLYRevenue && Number(widgetData?.vLYRevenue) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    budbgClass: (widgetData?.vBDRevenue && Number(widgetData?.vBDRevenue) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    fcbgClass: (widgetData?.fs_rev_percent && Number(widgetData?.fs_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    lyArrowClass: (widgetData?.vLYRevenue && Number(widgetData?.vLYRevenue) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    budArrowClass: (widgetData?.vBDRevenue && Number(widgetData?.vBDRevenue) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    fcArrowClass: (widgetData?.fs_rev_percent && Number(widgetData?.fs_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                },
                {
                    id: 4,
                    label: "Guest In house",
                    counter: !loading ? widgetData?.noOfAdultsInHotel:'',
                    lyPer: !loading ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.vLYCovers).toFixed(2)):'',
                    budPer: !loading ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.vBDCovers).toFixed(2)):'',
                    fcPer: !loading ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_table_occupancy).toFixed(2)):'',
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                    separator: "",
                    lybgClass: (widgetData?.vLYCovers && Number(widgetData?.vLYCovers) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    budbgClass: (widgetData?.vBDCovers && Number(widgetData?.vBDCovers) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    fcbgClass: (widgetData?.fs_table_occupancy && Number(widgetData?.fs_table_occupancy) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    lyArrowClass: (widgetData?.vLYCovers && Number(widgetData?.vLYCovers) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    budArrowClass: (widgetData?.vBDCovers && Number(widgetData?.vBDCovers) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    fcArrowClass: (widgetData?.fs_table_occupancy && Number(widgetData?.fs_table_occupancy) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    noOfAdults: (widgetData?.noOfAdultsInHotel) ? widgetData?.noOfAdultsInHotel : null
                },
                {
                    id: 5,
                    label: "Resident Cover Ratio",
                    counter: !loading ? widgetData.resCoverRatio+"%":'',
                    lyPer: !loading ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.vLYResCoverRatio).toFixed(2)) :'',
                    budPer: !loading ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.vBDResCoverRatio).toFixed(2)):'',
                    fcPer: '',
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                    separator: "",
                    lybgClass: (widgetData?.vLYCaptureRate && Number(widgetData?.vLYResCoverRatio) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    budbgClass: (widgetData?.vBDCaptureRate && Number(widgetData?.vBDResCoverRatio) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    fcbgClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    lyArrowClass: (widgetData?.vLYCaptureRate && Number(widgetData?.vLYResCoverRatio) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    budArrowClass: (widgetData?.vBDCaptureRate && Number(widgetData?.vBDResCoverRatio) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    fcArrowClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                },
                {
                    id: 6,
                    label: "Rev contribution for Resident",
                    counter: !loading ? widgetData.revContributionResident+"%":'',
                    lyPer: !loading ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.vLYRevContributionResident).toFixed(2)) :'',
                    budPer: !loading ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.vBDRevContributionResident).toFixed(2)):'',
                    fcPer: !loading ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_cover_percent).toFixed(2)):'',
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                    separator: "",
                    lybgClass: (widgetData?.vLYCaptureRate && Number(widgetData?.vLYRevContributionResident) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    budbgClass: (widgetData?.vBDCaptureRate && Number(widgetData?.vBDRevContributionResident) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    fcbgClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    lyArrowClass: (widgetData?.vLYCaptureRate && Number(widgetData?.vLYRevContributionResident) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    budArrowClass: (widgetData?.vBDCaptureRate && Number(widgetData?.vBDRevContributionResident) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    fcArrowClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                }
               
        ];
        setEcomWidgets(ecomWidgets);
    }, [widgetData, currency, loading]);
    
    return (
        <>
        <Row id="Widget">
                <CardBody className="p-0">
                {loading && <Loader />}    
                <div className={loading ? "opacity-0" : ""}>
                <Row id="overallFull">
                    {ecomWidgets.map((item, key) => (
                        <Col xl={4} key={key}>
                            <Card className="">
                                <CardBody>
                                    <div className="d-flex align-items-center">                            
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="fw-medium text-muted text-truncate mb-3">{item.label}</p>
                                            <div className="d-flex align-items-center mb-3">
                                                <h4 className="fs-4 flex-grow-1 mb-0">
                                                    <span className="counter-value me-1">                                                       
                                                        {item?.counter}
                                                    </span>
                                                </h4>
                                                
                                            </div>
                                            <div className="d-flex flex-wrap justify-content-between">
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.lybgClass}><i className={"fs-10 align-middle me-1 "+item.lyArrowClass}></i>{item.lyPer}</span>
                                                </p>
                                                
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.budbgClass}><i className={"fs-10 align-middle me-1 "+item.budArrowClass}></i>{item.budPer}</span>
                                                </p>
                                                
                                                {/* <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.fcbgClass}><i className={"fs-10 align-middle me-1 "+item.fcArrowClass}></i>{item.fcPer}</span>
                                                </p> */}
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
                </div> 
                </CardBody>
            {/* </Card> */}
        </Row>
        </>
    );
};

export default OverallWidget;
